import { Box, CircularProgress, Typography } from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import { createRef, useEffect, useState } from "react";
import "./DataTable.css";
import _ from "lodash";
import { NestedField } from "components/form/input/NestedField";

export default function DataTable({
    columns,
    rows,
    idField = "uid",
    nestedFieldName,
    loading,
    isMobile,
    noRows,
    ...props
}) {
    const [_columns, setColumns] = useState([]);
    const [_rows, setRows] = useState([]);
    const nodeRef = createRef();

    useEffect(() => {
        const c = columns.map((column) => {
            return {
                ...column,
                // Adiciona rótulos para permitir transpor a tabela em dispositivos mobile.
                sortComparator: (v1, v2, param1, param2) => {
                    let a = "";
                    let b = "";
                    // console.log('param1',param1)
                    if (column.valueGetter) {
                        a = param1.value;
                        b = param2.value;
                    } else {
                        a = _.get(param1.api.getRow(param1.id), param1.field);                        
                        b = _.get(param2.api.getRow(param2.id), param2.field);
                    }
                    if (column.compare) {
                        return column.compare(a, b);
                    }
                    // Comparação segura para strings
                    if (typeof a === 'string' && typeof b === 'string') {
                        return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }); // ignora acentos e case
                    }

                    if (a === b) return 0;
                    return a > b ? 1 : -1;
                },
                renderCell: (params, r1, r2) => {
                    let render = (
                        <>
                            <Typography className="cellLabel" sx={{ display: "none", fontWeight: "bold" }}>
                                {params.colDef.headerName}
                            </Typography>
                            {column.renderCellValue ? (
                                <>{column.renderCellValue(params.row, params)}</>
                            ) : (
                                <Typography className="cellContent" sx={isMobile ? { whiteSpace: "pre-wrap" } : {}}>
                                    {column.valueGetter ? params.value : _.get(params.row, params.field)}
                                </Typography>
                            )}
                        </>
                    );
                    if (nestedFieldName) {
                        console.log("params", params);
                        console.log("r1", r1);
                        console.log("r2", r2);

                        return (
                            <NestedField prefix={nestedFieldName} index={params.index}>
                                {render}
                            </NestedField>
                        );
                    }

                    return render;
                },
            };
        });

        setColumns(c);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns]);

    useEffect(() => {
        const r = rows.filter((row) => row[idField] !== undefined && row[idField] !== null);

        setRows(r);
    }, [idField, rows]);
    useEffect(() => {
        function updateHeight() {
            if (nodeRef.current) {
                // Corrige altura do interior do DataGrid, quando exibido em mobile sem o header.
                // Pode ser removido se um dia o DataGrid do MUI suportar não exibir o header.
                // const virtualScroller = nodeRef.current.querySelector(".MuiDataGrid-virtualScroller");
                // const heightReference = nodeRef.current.querySelector(".Mui-resizeTriggers .expand-trigger div");
                // if (virtualScroller && heightReference) {
                //     virtualScroller.style.height = heightReference.style.height;
                // }
            }
        }
        // TODO: encontrar uma solução melhor para atualizar após o MUI.
        setTimeout(updateHeight, 500);
    }, [nodeRef]);
    return (
        <Box
            ref={nodeRef}
            className="DataTable"
            sx={{
                display: "flex",
                // width: "100%",
                height: "100%",
                flex: 1,
                textAlign: "center",
                justifyContent: "center",
            }}
        >
            <DataGrid
                sortingOrder={['asc', 'desc']}
                columns={_columns}
                rows={_rows}
                getRowId={(row) => row[idField]}
                disableSelectionOnClick
                disableColumnMenu
                // hideFooterSelectedRowCount
                // hideFooterPagination
                disableVirtualization
                autoPageSize={props.autoPageSize}
                initialState={
                    isMobile
                        ? {
                            pagination: {
                                pageSize: 25,
                            },
                        }
                        : {
                            pagination: {
                                pageSize: 50,
                            },
                        }
                }
                components={{
                    LoadingOverlay: CircularProgress,
                }}
                loading={loading}
                localeText={{
                    noRowsLabel: noRows || "Nenhum Resultado",
                }}
                // funciona mas altura estática não fica legal
                // rowHeight={400} // altura das linhas

                componentsProps={
                    isMobile
                        ? {
                            cell: {
                                style: {
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                },
                            },
                        }
                        : {}
                }
                {...props}
            />
        </Box>
    );
}
